// The single opener for the app's IndexedDB. Every store module MUST go through this —
// two modules opening the same database at different versions throw VersionError at
// runtime, so the version and the store list live here and nowhere else.
const DB_NAME = 'motogo';
const DB_VERSION = 2; // v1: rides + ridePoints; v2: + routes

export const STORE_RIDES = 'rides'; // RideSummary + { synced }
export const STORE_RIDE_POINTS = 'ridePoints'; // { id, points }
export const STORE_ROUTES = 'routes'; // RouteDetail + { synced }

export function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      // Runs for fresh installs and for upgrades alike — createObjectStore is guarded so
      // a v1 database gains only the stores it's missing.
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_RIDES)) db.createObjectStore(STORE_RIDES, { keyPath: 'id' });
      if (!db.objectStoreNames.contains(STORE_RIDE_POINTS)) db.createObjectStore(STORE_RIDE_POINTS, { keyPath: 'id' });
      if (!db.objectStoreNames.contains(STORE_ROUTES)) db.createObjectStore(STORE_ROUTES, { keyPath: 'id' });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export function runTx(
  db: IDBDatabase,
  stores: string | string[],
  mode: IDBTransactionMode,
  work: (tx: IDBTransaction) => void,
): Promise<void> {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(stores, mode);
    work(tx);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  });
}

export function getAll<T>(db: IDBDatabase, store: string): Promise<T[]> {
  return new Promise((resolve, reject) => {
    const req = db.transaction(store, 'readonly').objectStore(store).getAll();
    req.onsuccess = () => resolve(req.result as T[]);
    req.onerror = () => reject(req.error);
  });
}

export function getOne<T>(db: IDBDatabase, store: string, key: string): Promise<T | undefined> {
  return new Promise((resolve, reject) => {
    const req = db.transaction(store, 'readonly').objectStore(store).get(key);
    req.onsuccess = () => resolve(req.result as T | undefined);
    req.onerror = () => reject(req.error);
  });
}
